/**
 * 计费口径（单一事实来源，前端展示用）。
 *
 * 权威定价在账号中心的 `oauth_clients.credit_policy.costs`：服务端 `/api/conversions/start`
 * 返回的 `cost` 才是实际扣费金额。本文件的常量只用于「发起前告知用户预期消耗」，
 * 以及未登录时的免费次数展示，因此：
 *
 * - 中心调价后必须同步这里，并同步 Worker 的 `LOCAL_COST` / `AI_COST`（见 docs/CREDITS-ROLLOUT.md）；
 * - 展示与实扣不一致时，以服务端返回值为准（前端会立即用返回值刷新，不做本地推算）。
 */

/** 本地转换单价（分/次）。 */
export const LOCAL_CONVERSION_COST = 1;

/** AI 识别转换单价（分/次）。 */
export const AI_CONVERSION_COST = 2;

/** 未登录用户每日免费转换次数（仅本地转换，AI 转换必须登录）。 */
export const ANONYMOUS_DAILY_FREE_LIMIT = 5;

/** AI 识别的单文件上限：页数与字节数（超出直接拒绝，不扣费）。 */
export const AI_MAX_PAGES = 20;
export const AI_MAX_BYTES = 20 * 1024 * 1024;
